<template>
    <!-- <p>
    <strong>Current route path:</strong> {{ $route.fullPath }}
  </p> -->
  <Analytics />
  <!-- RouterView has the same functionality as the above nav bar -->
  <!-- <main>
    <RouterView />
  </main> -->
  <b-container fluid>
    <div class="row">
      <div class="col-12 px-0">
        <router-view></router-view>
      </div>
    </div>
  </b-container>
</template>

<script>
import { Analytics } from '@vercel/analytics/nuxt'

export default {
  name: 'App',
  components: {
    Analytics
  },
}
</script>

